import { render, staticRenderFns } from "./JBProposalOverview.vue?vue&type=template&id=633cdeb7"
import script from "./JBProposalOverview.vue?vue&type=script&lang=js"
export * from "./JBProposalOverview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports